import React from "react";
import { Modal } from "antd";

import styles from "./styles/confirmDialog.scss";
import { getIconUrl } from "../../services/asset";

// extends from antd Modal's props
const ConfirmDialog = ({
  title,
  children,
  className,
  close,
  onOk,
  onCancel,
  ...rest
}) => (
  <Modal
    className={`${styles.confirmModal} ${className || ""}`}
    onOk={e => {
      onOk && onOk(e);
      close();
    }}
    onCancel={e => {
      onCancel && onCancel(e);
      close();
    }}
    okButtonProps={{
      className: styles.okButton,
    }}
    {...rest}
    maskClosable={false}
  >
    {title && (
      <div className={styles.title}>
        {title}{" "}
        <p className={styles.close} onClick={(e) => {
          onCancel && onCancel(e, true);
          close();
        }}>
          <img src={getIconUrl("remove.svg")} alt="x" />
        </p>
      </div>
    )}
    {children}
  </Modal>
);

ConfirmDialog.defaultProps = {
  title: null,
  children: null,
  className: "",
  close: null,
  onOk: null,
  onCancel: null
};

export default ConfirmDialog;



// WEBPACK FOOTER //
// ./src/components/ConfirmDialog/index.tsx